import { Cookies } from 'react-cookie';

import { VulsPeriodChartResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface GetVulsPeriodChartParams {
  slug: string;
  startDate: string;
  endDate: string;
}

export const getVulsPeriodChart = async ({
  slug,
  startDate,
  endDate,
}: GetVulsPeriodChartParams): Promise<VulsPeriodChartResponse> => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get(
    `/objects/${slug}/vulnerabilities/chart/?start_date=${startDate}&end_date=${endDate}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return response.data;
};
